import 'core-js/stable'
import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom'
import AppBase from '@/components/AppBase'

ReactDOM.render(<AppBase />, document.getElementById('root'))
